import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../Entity/RequestError";
import {AppThunk} from "../../app/store";
import {CartOfferDto} from "../Entity/Offer";
import {
  addItemOfferToCartRep, changeQuantityItemInOfferCartRep,
  getItemInOfferCartRep,
  removeItemInOfferCartRep, updateNotesInOfferCartRep
} from "../Repository/OfferRequestRepository";
import {PutItemToCartOfferRequest} from "../Entity/PutItemToCartRequest";
import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";

interface OfferCartState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isAddRequestSuccess: boolean,
  isRequestingChangeQuantitySuccess: boolean,
  isRequestFailed: boolean,
  isRequestingUpdateNote: boolean,
  isRequestUpdateNoteFailed: boolean,
  isUpdateNoteSuccess: boolean,
  error: RequestError | null,
  offerCart: CartOfferDto|null,
}

const OfferCartInitialState: OfferCartState = {
  isRequesting: false,
  isRequestingChangeQuantitySuccess: false,
  isRequestSuccess: false,
  isAddRequestSuccess: false,
  isRequestFailed: false,
  isRequestingUpdateNote: false,
  isRequestUpdateNoteFailed: false,
  isUpdateNoteSuccess: false,
  offerCart: null,
  error: null,
}

function startRequest(state: OfferCartState) {
  state.isRequesting = true;
  state.isRequestingChangeQuantitySuccess = false;
  state.isRequestFailed = false;
  state.offerCart = null;
}
function startChangeQuantityRequest(state: OfferCartState) {
  state.isRequesting = false;
  state.isRequestingChangeQuantitySuccess = true;
  state.isRequestFailed = false;
  state.offerCart = null;
}
function registerFailed(state: OfferCartState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestingChangeQuantitySuccess = false;
  state.isRequestSuccess = false;
  state.isAddRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerSuccess(state: OfferCartState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestingChangeQuantitySuccess = false;
  state.isRequestSuccess = true;
  state.isAddRequestSuccess = false;
  state.isRequestFailed = false;
  state.error = null;
  state.offerCart = action.payload;
  state.error = null;
}

function addRegisterSuccess(state: OfferCartState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestingChangeQuantitySuccess = false;
  state.isAddRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.offerCart = action.payload;
  state.error = null;
}

function resetAddSuccess(state: OfferCartState) {
  state.isAddRequestSuccess = false;
}

function updateNotesRequest(state: OfferCartState) {
  state.isRequestingUpdateNote = true;
  state.isRequestUpdateNoteFailed = false;
  state.isUpdateNoteSuccess = false;
  state.offerCart = null;
}
function updateNotesSuccess(state: OfferCartState, action: PayloadAction<any>) {
  if (state.offerCart) {
    state.isRequestingUpdateNote = false;
    state.isRequestUpdateNoteFailed = false;
    state.isUpdateNoteSuccess = true;
    state.offerCart.notes = action.payload;
  }
}
function updateNotesFailed(state: OfferCartState, action: PayloadAction<any>) {
  state.isRequestingUpdateNote = false;
  state.isRequestUpdateNoteFailed = true;
  state.isUpdateNoteSuccess = false;
  state.error = action.payload;
}
const OfferCartSlice = createSlice({
    name: 'OfferCart',
    initialState: OfferCartInitialState,
    reducers: {
      OfferCartStartRequest: startRequest,
      OfferCartAddSuccess: addRegisterSuccess,
      OfferCartSuccess: registerSuccess,
      OfferCartFailed: registerFailed,
      OfferCartStartChangeQuantityRequest: startChangeQuantityRequest,
      ResetAddSuccess : resetAddSuccess,
      UpdateNotesSuccess : updateNotesSuccess,
      UpdateNotesRequest : updateNotesRequest,
      UpdateNotesFailed: updateNotesFailed
    }
  }
)

export const {
  OfferCartStartRequest,
  OfferCartSuccess,
  OfferCartFailed,
  OfferCartAddSuccess,
  OfferCartStartChangeQuantityRequest,
  ResetAddSuccess,
  UpdateNotesSuccess,
  UpdateNotesRequest,
  UpdateNotesFailed
} = OfferCartSlice.actions;

export default OfferCartSlice.reducer;

export const addItemToOfferCart = (putItemToCartOfferRequest: PutItemToCartOfferRequest): AppThunk => async dispatch => {
  try {
    dispatch(OfferCartStartRequest());
    const newsApiResponse = await addItemOfferToCartRep(putItemToCartOfferRequest);
    dispatch(OfferCartAddSuccess(newsApiResponse));
  } catch (err) {
    dispatch(OfferCartFailed(err));
  }
}

export const getItemInOfferCart = (tokenOfferCart: string | null | undefined): AppThunk => async dispatch => {
  try {
    dispatch(OfferCartStartRequest());
    const newsApiResponse = await getItemInOfferCartRep(tokenOfferCart);
    dispatch(OfferCartSuccess(newsApiResponse));
  } catch (err) {
    dispatch(OfferCartFailed(err));
  }
}

export const removeItemFromOfferCart = (putItemToCartOfferRequest: PutItemToCartOfferRequest): AppThunk => async dispatch => {
  try {
    dispatch(OfferCartStartRequest());
    const newsApiResponse = await removeItemInOfferCartRep(putItemToCartOfferRequest);
    dispatch(OfferCartSuccess(newsApiResponse));
  } catch (err) {
    dispatch(OfferCartFailed(err));
  }
}

export const changeQuantityItemInOfferCart = (variantCode: string, quantity: number, tokenValue: string): AppThunk => async dispatch => {
  try {
    dispatch(OfferCartStartChangeQuantityRequest());
    const newsApiResponse = await changeQuantityItemInOfferCartRep(variantCode, quantity, tokenValue);
    dispatch(OfferCartSuccess(newsApiResponse));
  } catch (err) {
    dispatch(OfferCartFailed(err));
  }
}

export const updateNotesInOfferCart = (tokenValue: string, notes: string): AppThunk => async dispatch => {
  try {
    dispatch(UpdateNotesRequest());
    const newsApiResponse = await updateNotesInOfferCartRep(tokenValue, notes);
    dispatch(UpdateNotesSuccess(newsApiResponse));
    dispatch(getItemInOfferCart(tokenValue));
  } catch (err:any) {
    dispatch(UpdateNotesFailed(err));
  }
};
